const lastAction = (state = null, action) => action

export default lastAction